'use client'

import type { NavigationDesktopProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import classNames from 'classnames'

import { NavigationDesktopItem } from '@maestro/commerce-blocks/components/navigation-header'

import '@maestro/commerce-blocks/components/navigation-header/styles/navigation-desktop.scss'

export default function NavigationDesktop(props: NavigationDesktopProps) {
  const { customClassName, menu } = props
  return (
    <div className={classNames('nav-desktop', 'desktop-only', customClassName)}>
      <ul className="nav-desktop__list">
        {menu?.children?.map((node) => (
          <NavigationDesktopItem key={node._key} node={node} />
        ))}
      </ul>
    </div>
  )
}
